import React, { PureComponent } from 'react'
// import { Col, Row } from 'reactstrap'
import CartCard from './components/CartCard'
import { connect } from 'react-redux'

class Cart extends PureComponent {
  render () {
    return (
      <div className="cart-container">
        {/* <Row> */}
          <CartCard />
        {/* </Row> */}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    sidebar: state.sidebar
  }
}

export default connect(mapStateToProps, {})(Cart)



// WEBPACK FOOTER //
// ./src/components/e-commerce/cart/Cart.js